/**
 * 渠道商（sales_partner）模块通用字典与格式化工具
 *
 * 对应接口文档：资金账户多币种 & 设备激活补贴大洲/国家颗粒度
 * 注意：`*_cny` 字段名不代表人民币，单位一律以同级 `currency` 为准；
 *      不同币种金额不可相加/比较。
 */

/** 币种字典，新增币种在此扩展即可 */
export const CURRENCY_OPTIONS = [
    { label: '人民币（CNY）', value: 'CNY', symbol: '¥' },
    { label: '美元（USD）', value: 'USD', symbol: '$' },
    { label: '欧元（EUR）', value: 'EUR', symbol: '€' }
]

const CURRENCY_SYMBOL_MAP = CURRENCY_OPTIONS.reduce((acc, item) => {
    acc[item.value] = item.symbol
    return acc
}, {})

/**
 * 取币种符号，未收录的币种用币种码兜底，避免金额失去单位
 * @param {string} currency 币种码，如 CNY / USD / EUR
 * @returns {string}
 */
export const currencySymbol = (currency) => {
    if (!currency) return ''
    return CURRENCY_SYMBOL_MAP[currency] || `${currency} `
}

/**
 * 金额展示：币种符号 + 数值
 * @param {number|string} amount 金额
 * @param {string} currency 币种码（缺省时只展示数值）
 * @returns {string}
 */
export const formatAmount = (amount, currency) => {
    if (amount === null || amount === undefined || amount === '') return '-'
    return `${currencySymbol(currency)}${amount}`
}

/** 金额（不带符号）展示，缺失时占位 */
export const formatNumber = (value) => {
    if (value === null || value === undefined || value === '') return '-'
    return `${value}`
}

/** 币种下拉选项副本，供 el-select 使用 */
export const currencyOptions = () => CURRENCY_OPTIONS.map((item) => ({ label: item.label, value: item.value }))

/** 资金流水金额项（item_key）字典，接口字段名与数据库值一致 */
export const ITEM_KEY_OPTIONS = [
    { label: '可提现金额', value: 'amount_cny' },
    { label: '待结算金额', value: 'unsettled_amount_cny' },
    { label: '提取中的金额', value: 'frozen_amount_cny' },
    { label: '已经提取的金额(累计)', value: 'withdrawn_amount_cny' },
    { label: '相机生产补贴金额(累计)', value: 'device_factory_amount_cny' },
    { label: '相机激活补贴金额(累计)', value: 'device_activation_amount_cny' },
    { label: '云存收入佣金(累计)', value: 'order_commission_cny' }
]

const ITEM_KEY_MAP = ITEM_KEY_OPTIONS.reduce((acc, item) => {
    acc[item.value] = item.label
    return acc
}, {})

/** 资金流水金额项名称 */
export const itemKeyLabel = (itemKey) => ITEM_KEY_MAP[itemKey] || itemKey || ''

/** 设备激活补贴颗粒度：1 大洲，2 国家 */
export const GRANULARITY = {
    CONTINENT: 1,
    COUNTRY: 2
}

export const GRANULARITY_OPTIONS = [
    { label: '大洲', value: GRANULARITY.CONTINENT },
    { label: '国家', value: GRANULARITY.COUNTRY }
]

/** 颗粒度文案；历史配置缺省为 1（大洲） */
export const granularityLabel = (granularity) =>
    Number(granularity) === GRANULARITY.COUNTRY ? '国家' : '大洲'

/**
 * 区域展示名：优先用接口返回的 region_name，未匹配到时回退 region 码
 * 注意 AS/AF/NA/SA 既是大洲码也是国家码，展示时必须结合 granularity 判断
 * @param {string} region 大洲码或国家 ISO 码
 * @param {string} regionName 接口返回的 region_name（未匹配到 geo_country 时为空串）
 * @returns {string}
 */
export const regionDisplayName = (region, regionName) => regionName || region || ''
